export default __webpack_public_path__ + "static/media/ser3.e1876439.jpg";